import { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import Spinner from "../../spinner/Spinner";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { toast } from "react-toastify";


import formatDate from "../../../components/utils/DateFormatter";
const DeductedRemittanceDetails = () => {
  const [remittanceDetails, setRemittanceDetails] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { remittanceData } = location.state || {};

  useEffect(() => {
    if (remittanceData) {
      //Map the remittance data cleanly
      const mappedData = {
        id: remittanceData.id,
        remittance_number: remittanceData.remittance_number,
        type: remittanceData.type,
        type_label: remittanceData.type_label,
        amount: remittanceData.amount,
        description: remittanceData.description,
        branch_note: remittanceData.branch_note,
        status: remittanceData.status,
        rejection_reason: remittanceData.rejection_reason,
        reference: remittanceData.reference,
        submitted_at: remittanceData.submitted_at,
        approved_at: remittanceData.approved_at,
        completed_at: remittanceData.completed_at,
        created_at: remittanceData.created_at,
        time_ago: remittanceData.time_ago,
        branch: remittanceData.branch,
        initiator: remittanceData.initiator,
      };

      setRemittanceDetails(mappedData);
    }
  }, [remittanceData]);

  // Helper functions
  const Card = ({ title, children }) => (
    <div className="bg-white shadow-md rounded-2xl p-5 border border-gray-100">
      <h2 className="text-lg font-semibold text-darkGreen3 mb-4 border-b pb-2">
        {title}
      </h2>
      <div className="space-y-2">{children}</div>
    </div>
  );

  const InfoRow = ({ label, value, badge, highlight }) => (
    <div className="flex justify-between items-center py-1">
      <span className="text-gray-500 font-medium">{label}</span>
      {badge ? (
        <span
          className={`px-2 py-1 text-xs rounded-full ${value?.toLowerCase() === "pending"
            ? "bg-dash4 text-lGrey"
            : value?.toLowerCase() === "approved"
              ? "bg-darkGreen3 text-lGrey"
              : value?.toLowerCase() === "rejected"
                ? "bg-dash3 text-lGrey"
                : "bg-dash5 text-lGrey"
            }`}
        >
          {value}
        </span>
      ) : (
        <span
          className={`text-gray-800 ${highlight ? "font-semibold text-darkGreen3" : ""
            }`}
        >
          {value || "-"}
        </span>
      )}
    </div>
  );

  return (
    <MainLayouts>
      <div className="relative sm:rounded-lg py-6 w-full">
        <section className="w-full pr-[3%] pt-3 my-3 bg-gray-100">
          <nav className="bg-gray-200 py-0 px-4 rounded-lg">
            <ol className="list-none p-0 inline-flex mb-2">
              <li className="flex items-center">
                <p className="text-darkGreen3 pr-2">Operations Remittance</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-orange1">Deducted Details</p>
              </li>
            </ol>
          </nav>
        </section>

        {loading ? (
          <Spinner loading={loading} />
        ) : (
          <section className="text-gray-600 body-font">
            <div className="container">
              {/* Back button */}
              <div className="flex justify-end mb-3">
                <Link
                  to="/operations/branch/remittance/pending"
                  className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  <span className="flex justify-center sm:justify-start mx-2">
                    <ArrowLeftSquare className="mr-2" />
                    Back
                  </span>
                </Link>
              </div>

              {/* Details section */}
              <section className="text-gray-600 body-font px-4 lg:px-8 pb-10">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {/* LEFT SIDE */}
                  <div className="lg:col-span-2 space-y-6">
                    {/* Remittance Overview */}
                    <Card title="Remittance Overview">
                      <InfoRow
                        label="Remittance Number"
                        value={remittanceDetails.remittance_number}
                        highlight
                      />
                      <InfoRow
                        label="Reference"
                        value={remittanceDetails.reference}
                      />
                      <InfoRow
                        label="Type"
                        value={remittanceDetails.type_label}
                      />
                      <InfoRow
                        label="Amount"
                        value={CurrencyFormatter(remittanceDetails.amount)}
                        highlight
                      />
                      <InfoRow
                        label="Status"
                        value={remittanceDetails.status?.toUpperCase()}
                        badge
                      />
                      <InfoRow
                        label="Submitted Date"
                        value={formatDate(remittanceDetails.submitted_at)}
                      />
                      <InfoRow
                        label="Created Date"
                        value={formatDate(remittanceDetails.created_at)}
                      />
                      {/* <InfoRow
                        label="Time Ago"
                        value={remittanceDetails.time_ago}
                      /> */}
                    </Card>

                    {/* Description & Notes */}
                    <Card title="Description And  Notes">
                      <InfoRow
                        label="Description"
                        value={remittanceDetails.description}
                      />
                      <InfoRow
                        label="Branch Note"
                        value={remittanceDetails.branch_note}
                      />
                      {remittanceDetails.rejection_reason && (
                        <InfoRow
                          label="Rejection Reason"
                          value={remittanceDetails.rejection_reason}
                        />
                      )}
                    </Card>
                  </div>

                  {/* RIGHT SIDE */}
                  <div className="lg:col-span-1 space-y-6">
                    <Card title="Branch Information">
                      <InfoRow
                        label="Branch Name"
                        value={remittanceDetails.branch?.name}
                      />
                      <InfoRow
                        label="Email"
                        value={remittanceDetails.branch?.email}
                      />
                      <InfoRow
                        label="Phone"
                        value={remittanceDetails.branch?.phone_number}
                      />
                    </Card>

                    {/* <Card title="Approver / Initiator">
                      <InfoRow
                        label="Initiator"
                        value={
                          remittanceDetails.initiator?.fullname ||
                          "Not Assigned"
                        }
                      />
                      <InfoRow
                        label="Approved At"
                        value={formatDate(remittanceDetails.approved_at)}
                      />
                      <InfoRow
                        label="Completed At"
                        value={formatDate(remittanceDetails.completed_at)}
                      />
                    </Card> */}
                  </div>
                </div>
              </section>
            </div>
          </section>
        )}
      </div>
    </MainLayouts>
  );
};

export default DeductedRemittanceDetails;
